import { motion } from "framer-motion";

export default function Hero() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        {/* Desktop hero */}
        <motion.img
          initial={{ scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2, ease: [0.25, 0.46, 0.45, 0.94] }}
          src="/images/renders/hero.jpg"
          alt="FINORA Akdeniz Sahil Projesi"
          className="hidden md:block w-full h-full object-cover object-center"
        />
        {/* Mobile hero - compressed middle for better composition */}
        <motion.img
          initial={{ scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2, ease: [0.25, 0.46, 0.45, 0.94] }}
          src="/images/renders/hero-mobile.jpg"
          alt="FINORA Akdeniz Sahil Projesi"
          className="md:hidden w-full h-full object-cover object-center"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-[0.06] pointer-events-none">
        <img src="/images/brandmarks/brandmark-beyaz.svg" alt="" className="w-40 md:w-56" />
      </div>

      {/* Content - desktop: bottom, mobile: top (sky area) */}
      <div className="relative z-10 h-full flex flex-col justify-start pt-24 md:pt-0 md:justify-end pb-0 md:pb-24 max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <p className="font-sub text-white/50 text-[11px] sm:text-xs tracking-[0.3em] font-semibold mb-3 md:mb-5">
            FİNİKE, ANTALYA
          </p>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="font-heading text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-medium tracking-tight leading-[0.95] mb-4 md:mb-6"
        >
          Akdeniz'in<br />
          <span className="italic">Zamansız Kıyısı</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
          className="flex items-center gap-5"
        >
          <div className="w-14 h-[2px] bg-[#c13a05]" />
          <p className="font-sub text-white/75 text-[11px] sm:text-xs tracking-[0.25em] font-bold">
            HAYATIN TAM ZAMANI
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.1 }}
          className="mt-6 md:mt-10 flex items-center gap-6"
        >
          <button
            data-testid="hero-cta-button"
            onClick={() => scrollTo("contact")}
            className="group font-sub text-[11px] tracking-[0.18em] font-bold text-white border border-white/30 px-8 py-4 hover:bg-[#c13a05] hover:border-[#c13a05] transition-all duration-500 flex items-center gap-4"
          >
            BİLGİ ALIN
            <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
            </svg>
          </button>
          <button
            data-testid="hero-explore-button"
            onClick={() => scrollTo("brand-story")}
            className="font-sub text-[11px] tracking-[0.15em] font-semibold text-white/60 hover:text-white transition-colors duration-300"
          >
            KEŞFET
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2 }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          className="w-px h-10 bg-white/30"
        />
      </motion.div>
    </section>
  );
}
